import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Mic } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface MicDisclosureModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

export const MicDisclosureModal = ({
  isOpen,
  onAccept,
  onCancel,
}: MicDisclosureModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Mic className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center">
            {t("chat.mic_disclosure_title")}
          </DialogTitle>
          <DialogDescription className="text-center">
            {t("chat.mic_disclosure_intro")}
          </DialogDescription>
        </DialogHeader>

        <ul className="space-y-3 text-sm text-foreground/90">
          <li>
            <strong className="text-foreground">
              {t("chat.mic_disclosure_when").split(":")[0]}:
            </strong>
            {t("chat.mic_disclosure_when").slice(
              t("chat.mic_disclosure_when").indexOf(":") + 1
            )}
          </li>
          <li>
            <strong className="text-foreground">
              {t("chat.mic_disclosure_what").split(":")[0]}:
            </strong>
            {t("chat.mic_disclosure_what").slice(
              t("chat.mic_disclosure_what").indexOf(":") + 1
            )}
          </li>
          <li>
            <strong className="text-foreground">
              {t("chat.mic_disclosure_why").split(":")[0]}:
            </strong>
            {t("chat.mic_disclosure_why").slice(
              t("chat.mic_disclosure_why").indexOf(":") + 1
            )}
          </li>
          <li>
            <strong className="text-foreground">
              {t("chat.mic_disclosure_how").split(":")[0]}:
            </strong>
            {t("chat.mic_disclosure_how").slice(
              t("chat.mic_disclosure_how").indexOf(":") + 1
            )}
          </li>
          <li>
            <strong className="text-foreground">
              {t("chat.mic_disclosure_offline").split(":")[0]}:
            </strong>
            {t("chat.mic_disclosure_offline").slice(
              t("chat.mic_disclosure_offline").indexOf(":") + 1
            )}
          </li>
          <li className="text-muted-foreground">
            {t("chat.mic_disclosure_control")}
          </li>
        </ul>

        <DialogFooter className="flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button variant="ghost" onClick={onCancel}>
            {t("chat.mic_disclosure_cancel")}
          </Button>
          <Button variant="romantic" onClick={onAccept}>
            <Mic className="mr-2 h-4 w-4" />
            {t("chat.mic_disclosure_accept")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
